<template>
  <div class="my-bind">
    <!-- 绑定弹窗 -->
    <div id="bindPop" class="pop" v-show="mybind.show">
      <div class="content">
        <span class="close" @click="cancelBind"></span>
        <div class="input-wrapper">
          <div class="code">{{ mybind.vcode }}</div>
          <div class="copy" @click="copyEvent" :data-clipboard-text='mybind.vcode'>复制</div>
        </div>
        <div @click="bindEvent" :class='mybind.sending ? "btn forbid" : "btn"'>
          {{ mybind.sending ? `${mybind.num}（秒）` : `重新发送` }}
        </div>
        <div class="tips">
          绑定指引：<br />
          1、点击按钮复制验证码；<br />
          2、打开游戏菜单-领奖码，输入验证码即可成功绑定；<br />
          3、验证码有效期60秒，超过有效期请点击“重新获取”。
        </div>
      </div>
    </div>
    <!-- 绑定确认 -->
    <div id="bindConfirmPop" v-show="confirm" class="pop">
      <div class="content">
        <span class="close" @click="closePop('confirm')"></span>
        <h1>
          手机号<strong>{{ userinfo.phone }}</strong>即将绑定<br />
          <strong>{{ mybind.info.areaname }}丨{{ mybind.info.name }}</strong><br />
          一经绑定将无法解除绑定
        </h1>
        <ul class="btns-wrapper">
          <li @click="closePop('confirm')"></li>
          <li @click="confirmBind"></li>
        </ul>
        <div class="tips">每个手机号最多可绑定3个角色，绑定后不可解绑及修改。</div>
      </div>
    </div>
    <!-- 绑定成功 -->
    <div id="bindSuccessPop" v-show="success" class="pop">
            <div class="content">
                <span class="close" @click="closePop('success')"></span>
                <h1>游戏角色绑定成功！</h1>
                <div class="btn" @click="viewBindList">查看角色列表</div>
            </div>
        </div>
    <!-- 绑定列表 -->
    <div id="bindListPop" class="pop" v-show="bindlist.show">
      <div class="content">
        <span class="close" @click="hideBindList"></span>
        <ul v-if="bindlist.list.length">
          <li v-for="(item, index) in bindlist.list" :key="item.RoleName">
            <div class="img-wrapper">
              <img :src='`https://static.web.sdo.com/xuezu/pic/20220622_YuYue/avatar-${index}.jpg`' alt="" />
            </div>
            <span>{{ item.AreaName }}</span>
            <strong>{{ item.RoleName }}</strong>
          </li>
        </ul>
        <div class="blank" v-else>
          您暂未绑定任何角色哦~
        </div>
        <div class="btn-add" v-if="!bindlock" @click="goBind"></div>
        <div class="tips">
          每个手机号最多可绑定3个角色，绑定后不可解绑及修改。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import mixins from '../../mixins';
import { mapState } from 'vuex'
import { GetVCode,CheckVcode,ConfirmBind} from '../../api'
export default {
  name: 'Bind',
  mixins: [mixins],
  data() {
    return {
      confirm: false,
      success:false
    }
  },
  computed: {
    ...mapState(['mybind', 'bindlist', 'userinfo']),
    bindlock() {
      let flag = false;
      if (this.userinfo.bindlock === 1) {
        flag = true;
      } else {
        if (this.bindlist.list.length === 3) {
          flag = true;
        }
      }
      return flag;
    }
  },
  methods: {
    cancelBind() {
      this.mybind.show = false;
    },
    hideBindList() {
      this.bindlist.show = false;
    },
    viewBindList(){
      this.bindlist.show = true;
      this.success=false;
    },
    goBind() {
      this.bindlist.show = false;
      this.mybind.show = true;
      // 请求状态
      this.bindEvent();
    },
    copyEvent() {
      var clipboard = new ClipboardJS('.copy');
      clipboard.on('success', function (e) {
        CsLib.alert('复制成功');
      });
    },
    async bindEvent() {
      // 没有发送中
      if (!this.mybind.sending) {
        const vcode = await GetVCode();
        if (vcode) {
          this.mybind.sending = true;
          this.mybind.vcode = vcode;
          clearInterval(this.mybind.timer1);
          clearInterval(this.mybind.timer2);
          // 倒计时
          this.mybind.timer1 = setInterval(() => {
            this.mybind.num--;
            if (this.mybind.num <= 0) {
              clearInterval(this.mybind.timer1);
              clearInterval(this.mybind.timer2);
              this.mybind.num = 60;
              this.mybind.sending = false;
            }
          }, 1000)
          // 验证
          this.mybind.timer2 = setInterval(async () => {
            const res = await CheckVcode(vcode);
            if (res) {
              clearInterval(this.mybind.timer1);
              clearInterval(this.mybind.timer2);
              this.mybind.info = res;
              this.mybind.show = false;
              this.mybind.num = 60;
              this.mybind.sending=false;
              this.confirm=true;
            }
          }, 5000)
        }
      }
    },
    async confirmBind(){
      const res = await ConfirmBind();
      if(res=="-991"){
        this.confirm=false;
        this.goBind();
        return CsLib.alert('当前绑定角色信息有误！','error');
      }else if(res=="1"){
        this.confirm=false;
        this.success=true;
        this.bindlist.list.push({
          RoleName: this.mybind.info.name,
          AreaName: this.mybind.info.areaname
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
  background-repeat: no-repeat;
  background-size: 20rem 20rem;
}

#bindPop {
  .content {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/bindPop.png');
    width: 7.02rem;
    height: 4.72rem;
    margin-left: -3.51rem;
    margin-top: -2.36rem;
    box-sizing: border-box;
    padding-top: 1.56rem;

    .input-wrapper {
      width: 5.5rem;
      height: 0.78rem;
      margin: 0rem auto;
      background: #fff;
      display: flex;
      line-height: 0.78rem;
      border: 0.01rem solid #000;

      .code {
        text-align: center;
        flex-grow: 1;
        font-size: 0.4rem;
      }

      .copy {
        width: 2.41rem;
        @extend .icon;
        text-align: center;
        font-weight: bold;
        letter-spacing: 0.32em;
        background-position: -9.3rem -9.54rem;
      }
    }

    .btn {
      width: 3rem;
      height: 1rem;
      @extend .icon;
      margin: 0.48rem auto 0rem auto;
      text-align: center;
      line-height: 1rem;
      font-weight: bold;
      background-position: -12.28rem -9.56rem;

      &.forbid {
        filter: grayscale(100);
      }
    }

    .tips {
      bottom: -1.4rem;
      line-height: 1.4;
      align-items: flex-start;
    }
  }
}

#bindListPop {
  .content {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/bindListPop.png');
    width: 7.02rem;
    height: 6.02rem;
    margin-left: -3.51rem;
    margin-top: -3.01rem;
    box-sizing: border-box;
    padding-top: 1.6rem;

    .tips {
      bottom: -0.72rem;
      align-items: flex-start;
    }

    ul {
      width: 4.94rem;
      margin: 0rem auto;
      min-height: 2.6rem;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;

        .img-wrapper {
          width: 0.86rem;
          height: 0.86rem;
          overflow: hidden;
          border-radius: 50%;
          border: 0.02rem solid #000;
          background: #3bcfff;

          img {
            max-width: 100%;
            vertical-align: middle;
          }
        }

        span {
          color: rgba(0, 0, 0, 0.8);
          margin: 0rem 0.12rem;
        }

        strong {
          font-size: 0.3rem;
        }
      }
    }

    .blank {
      height: 2.6rem;
      text-align: center;

      &::before {
        content: "";
        display: block;
        width: 1.9rem;
        height: 2.11rem;
        @extend .icon;
        margin: 0rem auto;
        background-position: 0rem -10.55rem;
      }
    }

    .btn-add {
      width: 4.96rem;
      height: 1.1rem;
      @extend .icon;
      margin: 0rem auto;
      background-position: -2.72rem -10.75rem;
    }
  }
}

#bindConfirmPop {
  .content {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/bindConfirmPop.png');
    width: 7.02rem;
    height: 4.72rem;
    margin-left: -3.51rem;
    margin-top: -2.36rem;
    box-sizing: border-box;
    padding-top: 1.5rem;

    h1 {
      text-align: center;
      font-size: 0.26rem;
      line-height: 1.4;

      strong {
        color: #de381d;
      }
    }

    .btns-wrapper {
      bottom: 0.82rem;
    }

    .tips {
      align-items: flex-start;
    }
  }
}
#bindSuccessPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/bindSuccessPop.png');
        width: 7.02rem;
        height: 3.62rem;
        margin-left: -3.51rem;
        margin-top: -1.81rem;

        h1 {
            text-align: center;
            font-size: 0.38rem;
            color: #151515;
            padding-top: 0.98rem;
        }

        .btn {
            width: 3rem;
            height: 1rem;
            text-align: center;
            line-height: 1rem;
            @extend .icon;
            margin: 0.48rem auto 0rem auto;
            font-size: 0.26rem;
            background-position: -12.28rem -9.56rem;
        }
    }
}
</style>